<script>
import searchResultsTabMixin from '@phoenix/mixins/searchResultsTabMixin';
import SearchResultsTab from '@maison/components/search/SearchResultsTab';
import UserManualCard from '@maison/components/product/UserManualCard';
import { TAB_USER_MANUALS } from '@maison/helpers/search-helper';
import searchResultsTrackingMixin from '@maison/mixins/searchResultsTrackingMixin';
import { mapActions } from 'vuex';

export default {
  components: {
    SearchResultsTab,
    UserManualCard,
  },

  mixins: [searchResultsTabMixin, searchResultsTrackingMixin],

  data() {
    return {
      tab: TAB_USER_MANUALS,
    };
  },

  methods: {
    ...mapActions('search', ['setHasInteractedWithResults']),

    onStoreClick(manual, index) {
      this.setHasInteractedWithResults();
      this.sendSearchClickTracking(this.query, manual.url, index, 'manual');
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit">
    <div class="container">
      <div class="boutique-cards__grid">
        <UserManualCard
          v-for="(manual, index) in items"
          :key="index"
          :url="manual.url"
          :label="manual.label"
          :model="manual.model"
          :engraved-reference="manual.engravedReference"
          :language="manual.language"
          @click="onStoreClick(manual, index)"
        />
      </div>
    </div>
  </search-results-tab>
</template>
